import { useEffect, useRef, useState } from "react";

export default function AnimatedCounter({ value = 0, suffix = "+", prefix = "", duration = 1400, testId }) {
    const [display, setDisplay] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        if (!ref.current) return;
        const el = ref.current;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const target = Number(value) || 0;
                        const tick = (now) => {
                            const t = Math.min(1, (now - start) / duration);
                            const eased = 1 - Math.pow(1 - t, 3);
                            setDisplay(Math.round(target * eased));
                            if (t < 1) requestAnimationFrame(tick);
                        };
                        requestAnimationFrame(tick);
                    }
                });
            },
            { threshold: 0.3 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [value, duration]);

    return (
        <span ref={ref} data-testid={testId}>
            {prefix}
            {display.toLocaleString()}
            {suffix}
        </span>
    );
}
